<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ຂຶ້ນແຜນຕາມຄວາມຕ້ອງການຂອງສັນຍາ
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 2">
        <b-tab-item label="ສັນຍາທີ່ສົ່ງມາຜະລິດ">
          <b-filed>
            <b-field label="ລາຍການສັນຍາ">
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">#</th>
                    <th class="has-text-left " width="10%">
                      ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຊື່ບໍລິສັດ/ <br />
                      ລູກຄ້າ
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີສັນຍາ
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີ<br />ສົ່ງລາຍການ
                    </th>
                    <th class="has-text-left " width="5%">ຈຳນວນ<br />ທັງໝົດ</th>
                    <th class="has-text-left " width="5%">
                      ຈຳນວນ<br />ສົ່ງໃຫ້ສາຂາ
                    </th>
                    <th class="has-text-left " width="5%">
                      ຈຳນວນ<br />ສາຂາຮັບເອົາ
                    </th>
                    <th class="has-text-left " width="25%">
                      ສະຖານທີ່ສົ່ງສິນຄ້າ
                    </th>
                    <th class="has-text-left " width="25%">
                      ສະຖານຜະລິດເບື້ອງຕົ້ນ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຈັດການ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in contractlist" :key="data.ID">
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td>
                      {{ data.ID }} / {{ data.CONTRACTNO }}/
                      {{ data.SUBCONTRACTNO }}
                    </td>
                    <td>
                      {{ data.COMPANY }}
                    </td>
                    <td>
                      {{ dateFormatter(data.CONTRACTDATE) }}
                    </td>
                    <td>
                      {{ dateFormatter(data.SUMMITDATE) }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBEROFPRODUCTS }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBERSENDTOBRANCH }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBERBRANCHRECEIVE }}
                    </td>
                    <td>
                      {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                      {{ data.VILLAGE }}
                    </td>
                    <td>
                      ສາຂາ: {{ data.SELECTEDBRANCHNAME }} <br />
                      ແຂວງ: {{ data.SELECTEDPROVINCENAME }}
                    </td>
                    <td>
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        @click="
                          moredetail(
                            data.ID,
                            data.PROVINCEID,
                            data.PROVINCENAME,
                            data.COMPANY,
                            data.CONTRACTNO,
                            data.SUBCONTRACTNO
                          )
                        "
                        >ລາຍລະອຽດ
                      </b-button>
                    </td>

                    <td class="has-text-centered"></td>
                  </tr>
                </tbody>
              </table>
            </b-field>
          </b-filed>
        </b-tab-item>

        <b-tab-item label="ສັນຍາທີ່ສົ່ງໄປສາຂາແລ້ວ">
          <b-filed>
            <b-field label="ລາຍການສັນຍາ">
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="5%">#</th>
                    <th class="has-text-left " width="10%">
                      ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຊື່ບໍລິສັດ/ <br />
                      ລູກຄ້າ
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີສັນຍາ
                    </th>
                    <th class="has-text-left " width="10%">
                      ວັນທີ<br />ສົ່ງລາຍການ
                    </th>
                    <th class="has-text-left " width="5%">ຈຳນວນ<br />ທັງໝົດ</th>
                    <th class="has-text-left " width="5%">
                      ຈຳນວນ<br />ສົ່ງໃຫ້ສາຂາ
                    </th>
                    <th class="has-text-left " width="5%">
                      ຈຳນວນ<br />ສາຂາຮັບເອົາ
                    </th>
                    <th class="has-text-left " width="25%">
                      ສະຖານທີ່ສົ່ງສິນຄ້າ
                    </th>
                    <th class="has-text-left " width="10%">
                      ຈັດການ
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in contractbranchlist"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">{{ index + 1 }}</td>
                    <td>
                      {{ data.ID }}/ {{ data.CONTRACTNO }}/
                      {{ data.SUBCONTRACTNO }}
                    </td>
                    <td>
                      {{ data.COMPANY }}
                    </td>
                    <td>
                      {{ dateFormatter(data.CONTRACTDATE) }}
                    </td>
                    <td>
                      {{ dateFormatter(data.SUMMITDATE) }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBEROFPRODUCTS }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBERSENDTOBRANCH }}
                    </td>
                    <td class="has-text-right ">
                      {{ data.NUMBERBRANCHRECEIVE }}
                    </td>
                    <td>
                      {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                      {{ data.VILLAGE }}
                    </td>
                    <td>
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        @click="
                          moredetail(
                            data.ID,
                            data.PROVINCEID,
                            data.PROVINCENAME,
                            data.COMPANY,
                            data.CONTRACTNO,
                            data.SUBCONTRACTNO
                          )
                        "
                        >ລາຍລະອຽດ
                      </b-button>
                    </td>

                    <td class="has-text-centered"></td>
                  </tr>
                </tbody>
              </table>
            </b-field>
          </b-filed>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດ">
          <b-field v-if="!isDetail">
            <b-button
              class="btn-group-margin"
              type="is-primary"
              @click="goFirstTap()"
              >ເລືອກສັນຍາກ່ອນ, ກັບຄືນ
            </b-button>
          </b-field>
          <b-field v-if="isDetail">
            <div class="columns">
              <div class="column">
                <div>
                  <b-field group>
                    <b-field group style="float: right;">
                      <b-field>
                        <b-button
                          class="btn-group-margin"
                          type="is-primary"
                          @click="sendContractPlanToBranch()"
                          >ສົ່ງແຜນໃຫ້ສາຂາ
                        </b-button>
                      </b-field>
                      <b-field style="margin-left:15px;">
                        <b-button
                          class="btn-group-margin"
                          type="is-danger"
                          @click="clearContractPlanFromBranch()"
                          >ຍົກເລີກແຜນໃຫ້ສາຂາ
                        </b-button>
                      </b-field>
                    </b-field>
                  </b-field>
                </div>

                <div>
                  {{ selectedCompany }} {{ selectedContract }}
                  {{ selectedSubContract }} <br />{{
                    selectedContractProvinceid
                  }}
                  -
                  {{ selectedContractProvincename }}
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="10%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-left " width="15%">
                          ເກັບຜົນຜະລິດ
                        </th>
                        <th class="has-text-left " width="5%">
                          ປະເພດ
                        </th>

                        <th class="has-text-left " width="20%">
                          ສະຖານທີ່ສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="20%">
                          ສະຖານຜະລິດເບື້ອງຕົ້ນ
                        </th>

                        <th class="has-text-centered " width="30%">
                          ເລືອກສາຂາ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in newContractProductList(
                          selectedContractProvinceid
                        )"
                        :key="data.B2BID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td>{{ data.B2BAMOUNT }} {{ data.UNIT }}</td>
                        <td>
                          {{ dateFormatter(data.REDATE) }}
                        </td>
                        <td>
                          {{ data.TYPENAME }}
                        </td>
                        <td>
                          {{ data.PROVINCENAME }} <br />
                          {{ data.DISTRICT }} {{ data.VILLAGE }}
                        </td>
                        <td>
                          ສາຂາ: {{ data.SELECTEDDPPBRANCHNAME }} <br />
                          ແຂວງ: {{ data.SELECTEDDPPPROVINCENAME }}
                        </td>

                        <td class="has-text-centered">
                          <b-field v-if="data.B2BSTATUS == 2">
                            <Multiselect
                              placeholder="ເລືອກ"
                              v-model.trim="data.SELECTEDBRANCH"
                              label="NAME"
                              track-by="ID"
                              :options="branchList"
                              @input="onSelectedBranch"
                            >
                            </Multiselect>
                          </b-field>
                          <b-field v-if="data.B2BSTATUS == 3">
                            <b-button type="is-warning" size="is-small"
                              >ສົ່ງແຜນໄປສາຂາແລ້ວ
                            </b-button>
                            {{ data.BRANCHNAME }}
                          </b-field>
                          <b-field v-if="data.B2BSTATUS == 4">
                            <b-button type="is-primary" size="is-small"
                              >ສາຂາຮັບເອົາແຜນແລ້ວ
                            </b-button>
                            {{ data.BRANCHNAME }}
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-field>
        </b-tab-item>
      </b-tabs>
    </div>
    <div>
      <!-- - ເລືອກປີແຜນ/ທັງໝົດ ໃນ tap ສັນຍາສົ່ງຜະລິດ ແລະ ສັນຍາທີ່ສົ່ງຜະລິດແລ້ວ  -->
    </div>
    <!-- <div v-for="a1 in array1" :key="a1.ID">
                 {{a1.ID}}- {{ a1.NAME }} 
              
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="15%">
                          NAME
                        </th>
                        <th class="has-text-left " width="15%">
                          TYPE
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(a2,index) in newArray(a1.ID)"  :key="a2.ID">
                       
                          <td class="has-text-centered">{{ index + 1 }}</td>
                          <td>
                            {{ a2.ID }} - {{ a2.NAME }}
                          </td>
                          <td>
                            {{ a2.TYPE }}
                          </td>
                         
                      </tr>
                    </tbody>
                  </table>
                      
            </div> -->
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],
      // inactivemarkets: [],
      // b2buserid: null,
      // b2busername: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,
      isDetail: false,

      // activeSubTab: 0,
      // productType: [],
      // products: [],
      // productamount: [],
      // selecteddate: null,

      // quotaltoproduction: [],
      // activeQuotaSubTab: 0,
      // quotadate: null,
      // quotadatetypes: null,
      // quotadateproducts: null,
      // selectedquotaddate: null,
      // contractid: null,
      // contractno: null,
      // subcontractno: null,
      // countryList: [],
      // SelectedCountry: null,
      // ProvinceList: [],
      // SelectedProvince: null,
      // district: null,
      // village: null,
      // contractstatus: null,
      // contractdate: null,
      // contractdetail: null,
      contractlist: [],
      contractbranchlist: [],
      // isContractProductList: false,
      contractproductlist: [],
      yearList: [],
      selectedYear: null,
      activePlanYear: null,
      branchList: [],
      selectedBranch: [],
      contractProvinceList: [],
      selectedContractID: null,
      selectedContractProvinceid: null,
      selectedContractProvincename: null,
      // array1: [{"ID":"1","NAME":"AA"},{"ID":"2","NAME":"BB"}],
      // array2: [{"ID":"1","NAME":"AA","TYPE":"CC"},{"ID":"2","NAME":"BB","TYPE":"DD"},{"ID":"2","NAME":"AA","TYPE":"YY"}],
      // newArray: [],
      selectedCompany: null,
      selectedContract: null,
      selectedSubContract: null,
    };
  },
  methods: {
    newContractProductList(PROVINCEID) {
      return this.contractproductlist.filter(
        (a2) => a2.PROVINCEID == PROVINCEID
      );
    },

    newArray(ID) {
      return this.array2.filter((a2) => a2.ID == ID);
    },

    moredetail(
      contract,
      provniceid,
      provnicename,
      selectedCompany,
      selectedContract,
      selectedSubContract
    ) {
      console.log("moredetail ");
      this.isDetail = true;
      this.activeTab = 2;
      this.selectedContractID = contract;
      this.selectedContractProvinceid = provniceid;
      this.selectedContractProvincename = provnicename;
      this.getDppContractProductList(contract);
      this.selectedCompany = selectedCompany;
      this.selectedContract = selectedContract;
      this.selectedSubContract = selectedSubContract;
    },

    goFirstTap() {
      this.activeTab = 0;
    },

    getContractforDpp() {
      RestAPI.getContractforDpp() // 2 send to dpp

        .then((res) => {
          console.log("contractlist");
          console.log("contractlist:" + JSON.stringify(res.data.contractlist));
          console.log("-------------------");
          console.log("contractbranchlist");
          console.log(
            "contractbranchlist:" + JSON.stringify(res.data.contractbranchlist)
          );

          this.contractlist = res.data.contractlist;
          this.contractbranchlist = res.data.contractbranchlist;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // getContractBranchforDpp() {
    //   RestAPI.getContractforDpp(3) // 2 send to dpp
    //     .then((res) => {
    //       console.log("contractbranchlist");
    //       console.log("contractbranchlist:" + JSON.stringify(res.data));
    //       this.contractbranchlist = res.data;
    //       // this.inactivemarkets = res.data.inactivemarkets;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },

    getDppContractProductList(contractid) {
      this.isContractProductList = true;
      // console.log("this.contractid: " + this.contractid)
      RestAPI.getDppContractProductList(contractid)
        .then((res) => {
          this.contractproductlist = res.data;
          // console.log("products-: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    sendContractPlanToBranch() {
      console.log("selectedContract: " + this.selectedContractID);
      var params = {
        products: this.contractproductlist,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.sendContractPlanToBranch(params)
        .then((res) => {
          console.log("res:" + JSON.stringify(res.data));
          if (res.data == 0) {
            this.$swal("ກະລຸນາເລືອກແຂວງ", "", "warning");
          } else {
            this.contractlist = null;

            this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
            // this.getDppContractProductList(this.selectedContractID);
            // this.getContractforDpp();
            this.checkAllContractProductSendtoBranch(this.selectedContractID);
            this.activeTab = 1;
          }
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    checkAllContractProductSendtoBranch(contractno) {
      var params = {
        contractid: contractno,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.checkAllContractProductSendtoBranch(params)
        .then(() => {
          this.getContractforDpp();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    clearContractPlanFromBranch() {
      var params = {
        products: this.contractproductlist,
        username: this.username,
      };
      // console.log("params: ", JSON.stringify(params))
      RestAPI.clearContractPlanFromBranch(params)
        .then(() => {
          this.$swal("ຍົກເລີກສຳເລັດ ສຳເລັດ!", "", "success");
          // this.getDppContractProductList(this.selectedContractID);
          // this.getContractforDpp();
          this.checkAllContractProductSendtoBranch(this.selectedContractID);
          this.activeTab = 0;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    getYearList() {
      RestAPI.getYearList()
        .then((res) => {
          this.yearList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getActivePlanYear() {
      RestAPI.getActivePlanYear()
        .then((res) => {
          this.activePlanYear = res.data[0].NAME;
          // this.getDppContractProductList(this.activePlanYear);
          this.getContractProductProvince();
          console.log("activePlanYear: " + res.data[0].NAME);
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    // onYearSelected() {
    //   this.activePlanYear  =  this.selectedYear.NAME;
    //   this.getDppContractProductList(this.activePlanYear);

    // },
    getContractProductProvince() {
      console.log("this.activePlanYear: " + this.activePlanYear);
      RestAPI.getContractProductProvince(this.activePlanYear, 2)
        .then((res) => {
          this.contractProvinceList = res.data;
          // console.log("contractProvinceList: " + JSON.stringify(this.contractProvinceList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getBranchofProduction() {
      RestAPI.getBranches()
        .then((res) => {
          this.branchList = res.data.activebranches;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    onSelectedBranch() {
      // console.log("contractproductlist: " + JSON.stringify(this.contractproductlist))
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    // this.getB2bUser();
    // this.getCountry();
    this.getActivePlanYear();
    this.getYearList();
    this.getContractforDpp();
    this.getBranchofProduction();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}
</style>
